var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#47bba9",
    d: "M19.78 12.94c.14-.6.22-1.23.22-1.88s-.08-1.28-.22-1.88l1.67-1.3a.5.5 0 00.12-.64l-1.58-2.74a.5.5 0 00-.6-.22l-1.96.79a7.96 7.96 0 00-1.63-.95l-.3-2.07a.5.5 0 00-.5-.43h-3.16a.5.5 0 00-.5.43l-.3 2.07c-.58.25-1.12.57-1.63.95L4.61 5.28a.5.5 0 00-.6.22L2.43 8.24a.5.5 0 00.12.64l1.67 1.3c-.14.6-.22 1.23-.22 1.88s.08 1.28.22 1.88l-1.67 1.3a.5.5 0 00-.12.64l1.58 2.74c.13.23.4.33.64.22l1.96-.79c.51.38 1.06.7 1.63.95l.3 2.07a.5.5 0 00.5.43h3.16a.5.5 0 00.5-.43l.3-2.07c.58-.25 1.12-.57 1.63-.95l1.96.79c.24.1.51 0 .64-.22l1.58-2.74a.5.5 0 00-.12-.64l-1.67-1.3zM10.25 16.08l-3.11-3.11a.75.75 0 011.06-1.06l2.28 2.28 4.56-4.56a.75.75 0 111.06 1.06l-5.28 5.28a.75.75 0 01-1.06 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.9afd9a7db0f77e0ea26186ccc5c17bcb.svg";
export { ForwardRef as ReactComponent };